<template>
  <div class="container">
    <section>
      <div class="layout">
        <div class="child">
          <div class="pure-g">
            <div class="pure-u-1">
              <div>
                <h2>{{questionTitle}}</h2>
              </div>
            </div>
          </div>
          <div class="pure-g">
            <div class="pure-u-1">
              <div>
                <h3>
                  Now that you have created your study, tell us more about why you created it.
                </h3>
              </div>
            </div>
          </div>
          <div>
            <form class="pure-form pure-form-stacked" @submit.prevent="handleSubmit" novalidate>
              <fieldset>

                <div class="pure-g">
                  <div class="pure-u-1">
                    <textarea v-model="formModel.thoughts" :class="finalThoughtsValidationClassObj"
                              rows="5" :ref="textareaRefName"></textarea>
                  </div>
                </div>
                <div v-if="showFinalThoughtsValidationUI">
                  <div class="invalid">
                    <small>{{minimumCharacterWarning}}</small>
                  </div>
                </div>
                <button type="submit" class="hidden-submit"></button>
              </fieldset>
            </form>
          </div>
          <div>
            <form class="pure-form pure-form-stacked keyword-form" @submit.prevent="handleSubmitKeywordsForm"
                  novalidate>
              <fieldset>
                <div>
                  <h3>Please enter some keywords to associate with your study.</h3>
                </div>
                <div class="form-row">
                  <div class="pure-g">
                    <div class="pure-u-4-5">
                      <div class="form-row-section">
                        <input type="text" placeholder="New keyword" v-model="newKeyword">
                      </div>
                    </div>
                    <div class="pure-u-1-5">
                      <div class="form-row-section">
                        <button type="submit" class="pure-button add-keyword-button">Add</button>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="keywords-list-area" v-if="isKeywordsListNonEmpty">
                    <div class="pure-g">
                      <div class="pure-u-1" v-for="(keyword, index) in keywords">
                        <div class="keyword-row">
                          <span class="remove-keyword" @click="removeKeywordByIndex(index)">
                            <Fai :icon="['far', 'trash-alt']"/></span>
                          <span>{{keyword}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="pure-g">
                  <div class="pure-u-1" v-if="showKeywordsValidationUI">
                    <div class="pdng-1 top">
                      <div class="invalid">
                        <small>Please add at least one tag!</small>
                      </div>
                    </div>
                  </div>
                </div>

              </fieldset>
            </form>
          </div>
          <div>
            <BigStudyNavigation @touched="onTouched"></BigStudyNavigation>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import {
    GET_NEXT_STUDY_STEP_ROUTE,
    SET_IN_PROGRESS_STUDY_FINAL_THOUGHTS,
    PUSH_IN_PROGRESS_STUDY_KEYWORD,
    SPLICE_IN_PROGRESS_STUDY_KEYWORD,
    UPDATE_STUDY,
    CSS_CLASS_NAME_INVALID,
  } from '../../services/constants'

  const MIN_CHAR_LENGTH = 50

  export default {
    name: 'FinalThoughts',
    data() {
      return {
        formModel: null,
        submitTouched: false,
        newKeyword: '',
      }
    },
    computed: {
      ...mapGetters([
        GET_NEXT_STUDY_STEP_ROUTE,
      ]),
      questionTitle() {
        return 'FINAL THOUGHTS'
      },
      areFinalThoughtsValid() {
        return this.formModel.thoughts.trim().length >= MIN_CHAR_LENGTH
      },
      showFinalThoughtsValidationUI() {
        return !this.areFinalThoughtsValid && this.submitTouched
      },
      finalThoughtsValidationClassObj() {
        return {
          [CSS_CLASS_NAME_INVALID]: this.showFinalThoughtsValidationUI
        }
      },
      showKeywordsValidationUI() {
        return !this.isKeywordsListNonEmpty && this.submitTouched
      },
      isFormModelValid() {
        return this.areFinalThoughtsValid && this.isKeywordsListNonEmpty
      },
      textareaRefName() {
        return 'textareaRef'
      },
      keywords() {
        return this.$store.state.dataModule.inProgressStudy.keywords
      },
      isKeywordsListNonEmpty() {
        return this.keywords.length > 0
      },
      minimumCharacterWarning(){
        return `Don't pass up this chance to share your idea! Please write at least ${MIN_CHAR_LENGTH} characters`
      }
    },
    methods: {
      handleSubmit() {
        if (this.isFormModelValid) {
          this.$store.commit(SET_IN_PROGRESS_STUDY_FINAL_THOUGHTS, this.formModel.thoughts)
          this.$store.dispatch(UPDATE_STUDY).then(() => {
            this.$router.push(this[GET_NEXT_STUDY_STEP_ROUTE])
          })
        }
      },

      handleSubmitKeywordsForm() {
        if (this.newKeyword.length > 0) {
          this.$store.commit(PUSH_IN_PROGRESS_STUDY_KEYWORD, this.newKeyword)
          this.resetNewKeyword()
        }
      },
      removeKeywordByIndex(index) {
        this.$store.commit(SPLICE_IN_PROGRESS_STUDY_KEYWORD, index)
      },
      resetFormModel() {
        const finalThoughtsFromStore = this.$store.state.dataModule.inProgressStudy.finalThoughts
        this.formModel = Object.assign({}, {
          thoughts: finalThoughtsFromStore
        })
      },
      resetNewKeyword() {
        this.newKeyword = ''
      },
      focusFirstQuestion() {
        //$nextTick only needed for Chrome, firefox works without it
        this.$nextTick(() => {
          this.$refs[this.textareaRefName].focus()
        })
      },
      onTouched() {
        this.submitTouched = true
      },
    },
    created() {
      this.resetFormModel()
      this.resetNewKeyword()
    },
    mounted() {
      this.focusFirstQuestion()
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "../../scss/main";

  .container {
    height: 100%;
  }

  section {
    height: 100%;
  }

  .layout {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100%;
  }

  .child {
    width: 100%;
    max-width: 500px;
    margin: 1em;
  }

  h2 {
    text-align: center;
    color: $red-2;
  }

  h3 {
    color: $cyan-blue-3;
  }

  .pure-form input[type="text"], .pure-form textarea, select {
    box-shadow: none;
    width: 100%;
    color: $cyan-blue-3;
    border-color: $cyan-blue-3;
    &:focus {
      border-color: $cyan-blue-1;
    }
    &:placeholder-shown {
      color: $gray-3;
    }
    &:-ms-input-placeholder {
      color: $gray-3;
    }

    &.invalid {
      border-color: $red-2;
    }
  }

  .invalid {
    color: $red-2;
  }

  .form-row {
    color: $cyan-blue-3;
    font-size: 14px;

    .hint-section {
      padding: 10px;
    }
  }

  .form-row-section {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
  }

  .keyword-form {
    margin: 0 0 2em 0;
  }

  .add-keyword-button {
    width: 100%;
    margin: 0 0 0 10px;
  }

  .keywords-list-area {
    padding: 1em 0;
    color: $cyan-blue-3;
  }

  .remove-keyword {
    padding: 1em;
    cursor: pointer;
  }

  .keyword-row {
    display: flex;
    align-items: center;
  }

  .select-label {
    height: 100%;
    display: flex;
    align-items: center;
  }

  .question-title {
    font-size: 0.83em;
    font-weight: bold;
    color: $cyan-blue-3;
  }

  ::placeholder {
    color: $gray-3;
    opacity: 1;
  }

</style>
